export default function (state, getters, rootState, rootGetters) {
    return rootState.finances.paymentItems.form.data_report;
}